module.exports = __webpack_public_path__ + "static/media/Illus-BowlEmpty-Small@2x.19ee612b.png";